import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Authentication from "../components/PageComponent/Authentication/Authentication";

import { Loader } from "../components/atoms/Loader";
import { initRelatedListZoho } from "../util/RelatedListUtil";
import ModuleSetting from "../components/PageComponent/ModuleSetting/ModuleSetting";
import ShowError from "../components/atoms/ShowError";
import SnackAlert from "../components/atoms/SnackAlert";
import { getCloseSnakData, snackDetails } from "../config/otherConstant";
import RelatedListSetting from "../components/PageComponent/RelatedListSetting/RelatedListSetting";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function RelatedList(props) {
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [auth, setAuth] = useState(false);
  const [orgId, setOrgId] = useState(null);
  const [apiKey, setApiKey] = useState(null);
  const [zApiKey, setZApiKey] = useState(null);
  const [dataCenterUrl, setDataCenterUrl] = useState(null);
  const [dataCenter, setDataCenter] = useState(null);
  const [serviceApiKey, setServiceApiKey] = useState(null);
  const [zohoLoaded, setZohoLoaded] = useState(false);
  const [snack, setSnack] = useState(snackDetails);

  const [allUsers, setAllUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState();

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnack((prev) => getCloseSnakData(prev));
    // setOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    initRelatedListZoho((error, extensionData) => {
      if (error || !extensionData) {
        // Set Loading false
        setLoading((prev) => false);
        // Set Error Message
        return;
      }

      const {
        serviceAuth,
        orgId,
        apiKey,
        dataCenterUrl,
        zohoLoaded,
        zohoAuth,
        serviceApiKey,
        zApiKey,
        dataCenter,
        allUsers,
        currentUser,
      } = extensionData;

      setOrgId((prev) => orgId);
      setApiKey((prev) => apiKey);
      setDataCenterUrl((prev) => dataCenterUrl);
      setDataCenter((prev) => dataCenter);
      setAllUsers((prev) => allUsers);
      setCurrentUser((prev) => currentUser);

      setZApiKey((prev) => zApiKey);
      setServiceApiKey((prev) => serviceApiKey);
      setZohoLoaded((prev) => zohoLoaded);
      if (serviceAuth && zohoAuth) {
        setAuth((prev) => true);
      }
      setLoading((prev) => false);
    });
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!orgId || !apiKey || !dataCenterUrl) {
    return <ShowError />;
  }

  if (!auth) {
    return (
      <ShowError
        messge={"You are not authenticated. Please contact with admin"}
      />
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <h1>Successfully!!! You have data access</h1>
      </Box>

      <SnackAlert
        duration={snack?.duration}
        snackOpen={snack?.open}
        handleCloseSnack={handleCloseSnack}
        severity={snack?.severity}
        message={snack?.message}
      />
    </Box>
  );
}

export default RelatedList;
